import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class BlogService {
    constructor(private http: HttpClient) {
    }

    getArticleContent(id: string): Observable<string> {
        return this.http.get(`assets/blog/${id}.html`, {responseType: 'text'});
    }

    getArticlesList(): Observable<Array<{ title: string, description: string, id: string }>> {
        return this.http.get<Array<{ title: string, description: string, id: string }>>('assets/blog/articles.json');
    }
} 